import { GET_MILESTONES } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export const milestoneDefaultDataVersion = '1';

export interface Response {
    success: boolean;
    error?: string;
    milestones: IMilestoneData[];
    version?: string;
}

export type IMilestoneCategory =
    | 'ek-7084767782'
    | 'ek-1025408070'
    | 'ek-9916604356'
    | 'ek-9994397806'
// | 'other'
// | 'audio'
// | 'visual';


export interface IMilestoneData {
    id: string;
    categoryId: IMilestoneCategory;
    name: string;
    ageGroup: string;
    maxHrsFromBirth: number;
    category: string;
    archived?: boolean;
    created_at?: Date;
    updated_at?: Date;
}

export interface MilestoneData {
    data: {
        [categoryId: string]: {
            [milestone_id: string]: IMilestoneData;
        };
    };
    meta: {
        hrsFromBirth: number;
    };
}

export interface UIMilestone {
    [ageGroup: string]: MilestoneData;
}

export default (lastUpdated?: string, version?: string): Promise<Response> => {
    return fetchWithRefresh(GET_MILESTONES(lastUpdated, version)).then((res) => res.json());
};
